import { Button, Grid, Typography } from '@material-ui/core'
import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { postMember, typeMember, } from '../api/helpline/master'
import UserCreateForm from '../component/portal/usercreate/UserCreateForm'
import { useGlobalState } from '../provider/Provider'

interface Prop {
  handleError: (err: any) => void,
  handleNotificationOpen: (level: "success" | "info" | "warning" | "error", message: string) => void,
}

const ROOTPATH = process.env.REACT_APP_ROOT_PATH!

const UserCreate: React.FC<Prop> = (props) => {
  const globalState = useGlobalState('user')
  const { userId, token, role } = globalState
  const { handleError, handleNotificationOpen } = props
  const history = useHistory()


  const [telc, setTelc] = React.useState(false)
  const [emailc, setEmailc] = React.useState(false)
  const [loading, setLoading] = React.useState<boolean>(false)
  const [reqItem, setReqItem] = React.useState({
    userName: true,
    emailAddress1: true,
    telephoneNumber: true,
  })
  const [form, setForm] = React.useState<typeMember>({
    userCd: '',
    userName: '',
    emailAddress1: '',
    telephoneNumber: '',
    faxNumber: '',//変更不可
    departmentName: '',
    post: '',
    url: false,
  })

  const handleBackPage = () => {
    history.push(`${ROOTPATH}/member`)
  }

  const numberCheck = (telephone: string) => {
    let result = telephone.match(/^[0-9]{2,5}-[0-9]{2,5}-[0-9]{2,5}$/)
    let res = telephone.match(/[0-9]/g)
    if (!result) {
      setTelc(true)
    } else if (10 <= res!.length && res!.length <= 11) {
      setTelc(false)
    } else {
      setTelc(true)
    }
    return false
  }

  const mailCheck = (mail: string) => {
    let result = mail.match(/^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/)
    if (!result) {
      setEmailc(true)
    } else {
      setEmailc(false)
    }
    return false
  }

  //文字数カット
  const MAX_LENGTH_Department = 128
  const MAX_LENGTH_Post = 64
  const checkCutLength = (str: string, name: string): string => {
    let cutStr = str
    switch (name) {
      case 'userName':
      case 'emailAddress1':
      case 'departmentName':
        if (str.length > MAX_LENGTH_Department) {
          cutStr = str.substr(0, MAX_LENGTH_Department)
        }
        break
      case 'telephoneNumber':
      case 'post':
        if (str.length > MAX_LENGTH_Post) {
          cutStr = str.substr(0, MAX_LENGTH_Post)
        }
        break
    }
    return cutStr
  }

  const handleChangeForm = (event: React.ChangeEvent<{ value: unknown; name?: string | undefined }>) => {
    setForm({
      ...form,
      [event.target.name as string]: checkCutLength(event.target.value as string, event.target.name as string)
    })
  }

  const handleChangeChecked = (event: React.ChangeEvent<HTMLInputElement>) => {
    setForm({ ...form, [event.target.name]: event.target.checked });
  }

  const onSubmit = () => {
    setLoading(true)
    postMember(userId, token, role, form).then(res => {
      if (res) {
        handleNotificationOpen('success', 'ユーザーの新規登録')
        handleBackPage()
      }
      setLoading(false)
    }).catch(err => { setLoading(false); handleError(err) })
  }

  //必須項目チェックState更新
  useEffect(() => {
    setReqItem({
      ...reqItem,
      userName: form.userName ? false : true,
      emailAddress1: form.emailAddress1 ? mailCheck(form.emailAddress1) : true,
      telephoneNumber: form.telephoneNumber ? numberCheck(form.telephoneNumber) : true,
    })
  }, [form.userName, form.emailAddress1, form.telephoneNumber])

  return (
    <React.Fragment>
      <Grid container direction="row" justify="flex-start">
        <Typography variant="h6" style={{ flexGrow: 1 }}>
          メンバー新規登録
      </Typography>
        <Button variant="outlined"
          color="primary" size="small"
          onClick={handleBackPage}>戻る</Button>
      </Grid>
      <UserCreateForm
        handleChangeForm={handleChangeForm}
        form={form}
        reqItem={reqItem}
        emailc={emailc}
        telc={telc}
        loading={loading}
        onSubmit={onSubmit}
        handleChangeChecked={handleChangeChecked}
      />
    </React.Fragment>
  )
}

export default UserCreate
